import { EContactSaleSubmissionTag } from "../types/EnquiryEntry";

export function getLeadTag(tag: string) {
  if (tag === EContactSaleSubmissionTag.DUPLICATED_LEAD) return "Warm Lead";
  return tag
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getLeadTagTooltip(tag: string): string {
  if (tag === EContactSaleSubmissionTag.DUPLICATED_LEAD)
    return "This lead has enquired on other agents before. For more details, please read the Lead Insights.";
  if (tag === EContactSaleSubmissionTag.HOT_LEAD)
    return "This is a unique lead that has not enquired on other agents before.";
  if (tag === EContactSaleSubmissionTag.AGENT_LEAD)
    return "This lead is registered as an agent. Please check if it is a cobroke or JMA.";
  return "";
}
